import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

function StartRecipeButton({ id, type }) {
  const [disableStartButton, setDisabelStartButton] = useState(true);
  const [continueButton, setContinueButton] = useState(false);
  const history = useHistory();

  const getDoneRecipes = localStorage.getItem('doneRecipes');
  const doneRecipes = JSON.parse(getDoneRecipes) || [];

  const disableStartRecipe = () => {
    const done = doneRecipes.some((recipe) => recipe.id === id);

    if (done) {
      setDisabelStartButton(false);
    } else {
      setDisabelStartButton(true);
    }
  };

  const getInProgressRecipes = localStorage.getItem('inProgressRecipes');
  const inProgressRecipes = JSON.parse(getInProgressRecipes)
  || { meals: {}, cocktails: {} };

  const changeContinueButton = () => {
    const inProgress = Object.keys(inProgressRecipes.meals
      || inProgressRecipes.cocktails);
    const matchInProgress = inProgress.some((recipeId) => recipeId === id);
    if (matchInProgress) {
      setContinueButton(true);
    } else {
      setContinueButton(false);
    }
  };

  useEffect(() => {
    disableStartRecipe();
    changeContinueButton();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      { disableStartButton && (
        <button
          className="startRecipeButton"
          data-testid="start-recipe-btn"
          type="button"
          onClick={ () => history.push(`/${type}/${id}/in-progress`) }
        >
          { continueButton ? 'Continue Recipe' : 'Start Recipe' }
        </button>)}
    </div>
  );
}

StartRecipeButton.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default StartRecipeButton;
